module.exports = __webpack_public_path__ + "static/media/search-location.67719b92.svg";